/**
 * Detecta qué datos faltan en una startup
 */
export const detectarDatosFaltantes = (startup) => {
  const kpis = startup.datos?.kpis || {};
  const milestones = startup.datos?.milestones || [];
  
  const datosFaltantes = {
    kpis: [],
    milestones: false
  };
  
  // Verificar KPIs faltantes
  if (!kpis.ingresos || kpis.ingresos === null || kpis.ingresos === '') {
    datosFaltantes.kpis.push('Ingresos del trimestre');
  }
  
  if (!kpis.gastos || kpis.gastos === null || kpis.gastos === '') {
    datosFaltantes.kpis.push('Gastos del trimestre');
  }
  
  if (!kpis.empleados || kpis.empleados === null || kpis.empleados === '') {
    datosFaltantes.kpis.push('Número de empleados actual');
  }
  
  if (!kpis.runway || kpis.runway === null || kpis.runway === '') {
    datosFaltantes.kpis.push('Runway (meses de capital disponible)');
  }
  
  // Verificar ronda de financiación
  if (kpis.rondaAbierta === true || kpis.rondaAbierta === 'true') {
    if (!kpis.valoracion || kpis.valoracion === null || kpis.valoracion === '') {
      datosFaltantes.kpis.push('Valoración de la ronda');
    }
    if (!kpis.progresoRonda || kpis.progresoRonda === null || kpis.progresoRonda === '') {
      datosFaltantes.kpis.push('Progreso de la ronda');
    }
  } else {
    // Si no sabemos si hay ronda abierta, preguntar
    if (kpis.rondaAbierta === null || kpis.rondaAbierta === undefined || kpis.rondaAbierta === '') {
      datosFaltantes.kpis.push('¿Tienes una ronda de financiación abierta? (Sí/No)');
    }
  }
  
  // Verificar milestones
  if (!milestones || milestones.length === 0) {
    datosFaltantes.milestones = true;
  }
  
  return datosFaltantes;
};

/**
 * Genera el cuerpo del email personalizado solicitando solo los datos faltantes
 */
export const generarEmailPersonalizado = (startup, reporte, datosFaltantes) => {
  const { fundadorNombre, startupNombre, reporteNombre } = {
    fundadorNombre: startup.fundador || 'Fundador',
    startupNombre: startup.nombre,
    reporteNombre: reporte.nombre
  };
  
  let cuerpo = `Hola ${fundadorNombre},\n\n`;
  
  // Si ya hay algunos datos, mencionarlo
  const tieneAlgunDato = (startup.datos?.kpis && Object.keys(startup.datos.kpis).some(k => {
    const valor = startup.datos.kpis[k];
    return valor !== null && valor !== undefined && valor !== '';
  })) || (startup.datos?.milestones && startup.datos.milestones.length > 0);
  
  if (tieneAlgunDato) {
    cuerpo += `Gracias por la información que ya nos has proporcionado sobre ${startupNombre} para el ${reporteNombre}.\n\n`;
    cuerpo += `Para completar el reporte, aún necesitamos los siguientes datos:\n\n`;
  } else {
    cuerpo += `Te escribo para recordarte que aún necesitamos la información trimestral de ${startupNombre} para el ${reporteNombre}.\n\n`;
    cuerpo += `Por favor, cuando tengas un momento, comparte los siguientes datos:\n\n`;
  }
  
  // KPIs faltantes
  if (datosFaltantes.kpis.length > 0) {
    cuerpo += `**KPIs Financieros:**\n`;
    datosFaltantes.kpis.forEach(kpi => {
      cuerpo += `- ${kpi}\n`;
    });
    cuerpo += `\n`;
  }
  
  // Milestones faltantes
  if (datosFaltantes.milestones) {
    cuerpo += `**Hitos Relevantes del Trimestre:**\n`;
    cuerpo += `Por favor, comparte los hitos más importantes del trimestre en las siguientes áreas:\n`;
    cuerpo += `- Comercial\n`;
    cuerpo += `- Producto\n`;
    cuerpo += `- Tecnología\n`;
    cuerpo += `- Recursos Humanos\n`;
    cuerpo += `- Financiero\n`;
    cuerpo += `- General\n`;
    cuerpo += `- Otros\n\n`;
  }
  
  if (tieneAlgunDato) {
    cuerpo += `Si ya enviaste esta información y no la hemos recibido, por favor reenvíala.\n\n`;
  }
  
  cuerpo += `Gracias por tu atención.\n\n`;
  cuerpo += `Saludos cordiales`;
  
  return cuerpo;
};

